/**
 * @param {string|null}cartState
 */
/**
 * @param {string} cartState - 要更新的 cartState token
 * @param {(element: HTMLInputElement) => void} [insertFn] - 選填：用來插入 input 的函式
 */
export function updateCartStateToken(cartState, insertFn) {
    let cartStateElement = document.querySelector('input[name="cart_state_token"]');
    if (cartStateElement) {
        cartStateElement.value = cartState;
    } else {
        const newCartStateElement = document.createElement('input');
        newCartStateElement.type = 'hidden';
        newCartStateElement.name = 'cart_state_token';
        newCartStateElement.value = cartState;
        insertFn(newCartStateElement);
    }
}
